import { useLayoutEffect, useRef } from 'react';
import { gsap } from 'gsap';

// Motion for the editor: short GSAP tweens on transform and opacity only (no layout
// properties), so panels, popovers and swaps stay on the compositor. Reduced motion
// settles everything instantly.
export const reducedMotion = () => typeof window !== 'undefined' && !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
const timing = vars => ({ duration: reducedMotion() ? 0 : vars.duration ?? 0.18, ease: vars.ease || 'power2.out' });

export const enter = (target, from = {}, vars = {}) => target && gsap.fromTo(target, { autoAlpha: 0, ...from }, { autoAlpha: 1, x: 0, y: 0, scale: 1, ...vars, ...timing(vars), overwrite: 'auto' });
export const leave = (target, to = {}, vars = {}) => new Promise(resolve => {
  if (!target) { resolve(); return; }
  gsap.to(target, { autoAlpha: 0, ...to, ...vars, ...timing({ duration: 0.12, ...vars }), overwrite: 'auto', onComplete: resolve });
});
export const tween = (target, vars) => target && gsap.to(target, { ...vars, ...timing(vars), overwrite: 'auto' });

// Plays an entrance whenever `key` changes (the inspector swapping sections, a panel tab).
export function useEnter(key, from = { y: 6 }, vars) {
  const ref = useRef(null);
  useLayoutEffect(() => {
    const animation = enter(ref.current, from, vars);
    return () => animation?.kill();
  }, [key]); // eslint-disable-line react-hooks/exhaustive-deps
  return ref;
}

export { gsap };
